module.exports = __webpack_public_path__ + "static/media/daniel.7fbbbde4.JPG";